import React from "react";

const Heading = (props) => {
  return (
    <>
      <h2 className="main-heading">{props.headingText}</h2>
    </>
  );
};

export default Heading;
